import React, { useEffect, useState } from 'react';
import ProductList from './ProductList';
import NavbarBack from './NavbarBack'; // ✅ Import navbar

const LikedProducts = () => {
  const [likedProducts, setLikedProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);

  useEffect(() => {
    const username = localStorage.getItem('username');
    if (!username) return;

    // Fetch all products
    fetch('https://reviewhub-lc.onrender.com/api/reviews/all')
      .then(res => res.json())
      .then(data => setAllProducts(data));

    // Fetch liked product IDs
    fetch('https://reviewhub-lc.onrender.com/api/auth/get-likes', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username }),
    })
      .then(res => res.json())
      .then(data => setLikedProducts(data.likes || []));
  }, []);

  const likedOnly = allProducts.filter(p => likedProducts.includes(p._id));

  return (
<>
  <NavbarBack title="Liked Products" />
  <ProductList products={likedOnly} showFilters={false} />
</>

  );
};

export default LikedProducts;
